import React, { JSXElementConstructor, ReactElement } from 'react';
import { history } from 'umi';
import { isFunction } from 'lodash-es';
import { datamapIntelligenceMetricsPath, datamapIntelligenceSourcesPath } from '@/pages/intelligence/utils/common';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import { DATASOURCE_NAME } from '@intelligence/components/DataSourceComponents';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { dataSourcePageIDMap } from '@intelligence/components/DataSourceComponents/DataSourceBubbleInfo/config';
interface PropsType {
  dataOfDom?: ReactElement<any, string | JSXElementConstructor<any>> | string;
  comesFormDom?: React.ReactElement;
  customActions?: (...args: any[]) => void;
  dataSource?: string;
  isNoMore?: boolean;
  isNewMore?: boolean;
  metricKey?: string;
  entityType?: string;
  textContentExtraKey?: string;
}

export default function DataSourceBubbleInfo(props: PropsType) {
  const { formatMessage } = useIntlExtend(); // 中英切换方法
  const {
    dataOfDom,
    comesFormDom,
    dataSource,
    customActions,
    isNoMore = false,
    isNewMore = false,
    metricKey = '',
    entityType = '',
    textContentExtraKey,
  } = props;

  // console.debug('DataSourceBubbleInfo', props);

  const isHasDataSourceMap = () => {
    switch (dataSource) {
      // case 'ampere':
      //   return false;
      default:
        return true;
    }
  };

  const getDataSourceName = () => {
    switch (dataSource) {
      case 'ampere':
        return 'dbi_other_vendor';
      default:
        // return dataSource;
        return '';
    }
  };

  return (
    <span>
      {isNewMore ? (
        <>
          <span>
            {formatMessage({ id: 'dbi_metric_table_head_datasource' })}
            {formatMessage({ id: getDataSourceName() })}
            {comesFormDom}
          </span>
        </>
      ) : (
        <>
          {/* 游戏重叠度分析 / Steam游戏 Steam Overlap 表头提示需额外定制展示内容 */}
          {textContentExtraKey ? (
            <span>
              {formatMessage(
                {
                  id: textContentExtraKey,
                },
                {
                  steam: (
                    <>
                      <img src={getDataSourceIcon('steam')} />
                      {DATASOURCE_NAME.steam}
                    </>
                  ),
                },
              )}
            </span>
          ) : (
            // 通用内容展示（DataBrain隐藏来源文案和图标）
            (dataSource === 'databrain') ? null : (
              <span>
                {dataOfDom ? formatMessage(
                  {
                    id: dataSource === 'newzoo' ? 'dbi_metric_dataof_generatedby' : 'dbh_metric_dataof_comesfrom',
                  },
                  {
                    sourceName: dataOfDom,
                  },
                )
                  : formatMessage({ id: 'dbh_metric_dataof_comes' })}
                {dataSource === 'weixin' || dataSource === 'douyin' ? formatMessage({ id: 'dbi_wechat_gravity_engine' }) : comesFormDom}
                {dataSource === 'newzoo' ? formatMessage({ id: 'dbi_metric_dataof_generatedby_suf' }) : ''}
              </span>
            )
          )}
        </>
      )}
      {/* 新版更多按钮 */}
      {isNewMore || dataSource === 'weixin' || dataSource === 'douyin' ? (
        // 对于 DataBrain 数据源隐藏“了解更多”
        (dataSource !== 'databrain' && dataSource !== 'weixin' && dataSource !== 'douyin') ? (
          <span
            style={{
              color: isHasDataSourceMap() ? '#326FF0' : '#838697',
              paddingLeft: '5px',
              cursor: isHasDataSourceMap() ? 'pointer' : '#default',
            }}
            onClick={(e) => {
              // 如果datamap没有此数据源，则不反应点击
              if (!isHasDataSourceMap()) return;
              if (isFunction(customActions)) {
                e?.stopPropagation();
                e?.preventDefault();
                customActions();
                return;
              }
              if (dataSource) {
                // 默认跳转到Metrics,特殊跳转请在customActions函数调用
                history.push({
                  pathname: datamapIntelligenceMetricsPath,
                  query: {
                    metric: metricKey,
                    pageid: dataSourcePageIDMap[dataSource] || dataSource,
                    gameType: entityType || '',
                  },
                });
              } else {
                history.push(datamapIntelligenceMetricsPath);
              }
            }}
          >
            {formatMessage({ id: 'dbh_learnmore' })}
          </span>
        ) : null
      ) : (
        <>
          {/* 旧-更多按钮 */}
          {!isNoMore && dataSource !== 'databrain' && (
            <span
              style={{ color: '#326FF0', paddingLeft: dataOfDom ? '5px' : '0px', cursor: 'pointer' }}
              onClick={(e) => {
                if (isFunction(customActions)) {
                  e?.stopPropagation();
                  e?.preventDefault();
                  customActions();
                  return;
                }
                if (dataSource) {
                  // Gamalytic 指标跳转到 Sources 页面并选中 Gamalytic
                  if (dataSource === 'gamalytic') {
                    history.push({
                      pathname: datamapIntelligenceSourcesPath,
                      query: {
                        sourceValue: 'Gamalytic',
                      },
                    });
                  } else if (dataSource === 'alinea') {
                    // Alinea 指标跳转到 Sources 页面并选中 Alinea
                    history.push({
                      pathname: datamapIntelligenceSourcesPath,
                      query: {
                        sourceValue: 'Alinea',
                      },
                    });
                  } else if (dataSource === 'source_steam') {
                    // source_steam 指标跳转到 Sources 页面并选中 Steam
                    history.push({
                      pathname: datamapIntelligenceSourcesPath,
                      query: {
                        sourceValue: 'Steam',
                      },
                    });
                  } else {
                    // 默认跳转到Metrics,特殊跳转请在customActions函数调用
                    history.push({
                      pathname: datamapIntelligenceMetricsPath,
                      query: {
                        metric: metricKey,
                        pageid: dataSource === 'newzoo' ? 'ogdb' : dataSource,
                        gameType: entityType || '',
                      },
                    });
                  }
                } else {
                  history.push(datamapIntelligenceMetricsPath);
                }
              }}
            >
              {formatMessage({ id: 'dbh_learnmore' })}
            </span>
          )}
        </>
      )}
    </span>
  );
}
